import React from 'react'
import Tilt from 'react-tilt'
import Image from 'react-bootstrap/Image'

import '../assets/css/prizes_new.css'



function Speakers(props) {
    const speakers = props.speakers

   
  return (
      <>
    <h1>{props.title}</h1>
    <div class="about-container poems">
        {
             Object.entries(speakers).map(([key,value]) => {
                return (
               
                    <Tilt style={{ backgroundColor: "transparent" , zIndex: "1" }}>
                        <div class="card-new">
                            <div class="content" style={{ backgroundColor: "transparent" , zIndex: "1" }}>
                            <Image
                            style={{width: 80,
                                height: 80,
                                borderColor: 'red',
                                borderWidth: 2,
                                borderRadius: 75}}
                            src={value.image}
                            resizeMode={"cover"} // <- needs to be "cover" for borderRadius to take effect on Android
                            />

                                 {/* <img src="https://picsum.photos/200"   /> */}
                                <h2 class="id">{value.id}</h2>
                                <h4 class="titles" style={{color : '#fff' , marginBottom:'50px'}}>{value.name}</h4>
                                <h5 class="openings" style={{color : '#fff'}}>{value.des}</h5>
                                <p style={{color : '#fff'}}>{value.description}</p>
                            </div>
                        </div>
                    </Tilt>
               
                )
            })
        }

        
    </div>
    </>
  )
}


export default Speakers